import React from 'react';

function SVGDropdownIcon (props) {
    return (
        <svg {...props} viewBox="0 0 24 24" className="wdp-icon-dropdown">
            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path>
        </svg>
    );
}

export default SVGDropdownIcon;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/DropdownIcon.js
 **/